import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: '{symbol} Reserve Overview' },
  deposit: { defaultMessage: 'Deposit' },
  borrow: { defaultMessage: 'Borrow' },
});
